import { render, staticRenderFns } from "./SliderItemLogin.vue?vue&type=template&id=1154dcfe&scoped=true&"
import script from "./SliderItemLogin.vue?vue&type=script&lang=js&"
export * from "./SliderItemLogin.vue?vue&type=script&lang=js&"
import style0 from "./SliderItemLogin.vue?vue&type=style&index=0&id=1154dcfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1154dcfe",
  null
  
)

export default component.exports